
import React, {Component} from 'react';
import {Modal,Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
const Barcode = require('react-barcode');

class EmployeeBarCodeModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {}
  }

  onDownloadClick(){
    
  }

  renderQR(){
    let {value,label,subLabel} = this.props
    if(value!==''){
      return (
            <div id='qr_capture' style={{width:'256px',height:'320px',display:'inline-block'}}>
              
              <Barcode 
                value={value}
                width={2}
                height={30}
                textAlign={'center'}
                fontSize={12}
              />
            
              <div>
                <h4>{label}</h4>                
              </div>
              <div id='qr_canvas'/>
            </div>
      )
    }else{
      return(
      <div>
        <span className='text-red'>มีข้อผิดพลาด ไม่พบ URL ติดต่อแอดมิน</span>
      </div>
      )
    }
  }

  render(){
    let {show,title,value} = this.props
    
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="smallwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='text-center'>
            {this.renderQR()}            
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button style={{display:'none'}} onClick={this.onDownloadClick.bind(this)}><FontAwesome name='download'/>ดาวโหลดไฟล์</Button>
          <Button onClick={this.props.onHide}><FontAwesome name='close'/>ปิดหน้าต่าง</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

EmployeeBarCodeModal.defaultProps = {
  title: 'Bar Code',  
  value :'',
  label:'',
  subLabel:''
}

export default EmployeeBarCodeModal;





// WEBPACK FOOTER //
// ./src/view/hr/EmployeeBarCodeModal.js